export function isOneNumberValid(value, t) {
    if (!value) return true;

    const isValid = /\d/.test(value);

    if (!isValid) {
        return t('address__error--numberRequired');
    }

    return true;
}

export function isPoBoxValid(value, t) {
    if (!value) return true;

    const lowercaseValue = value.toLowerCase();

    // Check for various forms of P.O. Box
    const poBoxPatterns = [
        'p o box',
        'po box',
        'p.o box',
        'p.o. box',
        'pobox',
        'pob',
        'fpo',
    ];

    const isValid = !poBoxPatterns.some((pattern) => {
        const regex = new RegExp(`\\b${pattern}\\b`, 'i');
        return regex.test(lowercaseValue);
    });

    if (!isValid) {
        return t('address__error--poBoxesNotPermitted');
    }

    return true;
}
